export default __webpack_public_path__ + "static/media/rarity-img2-2.4fb35855.png";